import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { CatalogService } from '@catalog/catalog.service';
import { ToastrService } from 'ngx-toastr';
import { DATA_PER_PAGE, CANCEL } from './../../../../app.constant';
import { CommonDataService } from '@shared/catalogue/services/common-data.service';
import { ErrorHandler } from '@root/utils/error-handler.service';

@Component({
  selector: 'app-catalogue-articles-list',
  templateUrl: './catalogue-articles-list.component.html',
  styleUrls: ['./catalogue-articles-list.component.scss'],
  providers: [CatalogService],
})
export class CatalogueArticlesListComponent implements OnInit {
  @Input() data: any[];

  @Input() type: string;

  @Input() enableCeoSpecificFields: boolean;

  @Output() editChange: EventEmitter<any> = new EventEmitter<any>();

  @Output() uploadThumbnailChange: EventEmitter<any> = new EventEmitter<any>();

  pageSize: number = DATA_PER_PAGE;

  selectedType: string;

  panelMap: { [key: string]: boolean } = {};

  constructor(
    private catalogService: CatalogService,
    private toastr: ToastrService,
    public commonDataService: CommonDataService,
    private errorHandler: ErrorHandler
  ) {}

  ngOnInit() {}

  public readArticles(type) {
    const obj = {
      type: type ? type : '',
      year: "",
      month: ""
    };

    this.catalogService.readArticles(obj).subscribe(
      (response) => {
        if (response.status === 0) {
          this.data = [...response.data.articles];
        }
      },
      (error) => {}
    );
  }

  public viewFile(path) {
    window.open(path, '_blank');
  }

  onEdit(obj: any) {
    this.editChange.emit(obj);
    this.scrollTop();
  }

  scrollTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  public deleteData(data: any) {
    this.commonDataService
      .confirm('Are you sure want to delete?', 'md')
      .then((confirmed) => {
        if (confirmed) {
          const obj = {
            id: data.id,
          };
          this.catalogService.deleteArticle(obj).subscribe(
            (response) => {
              if (response.status === 0) {
                this.toastr.success(response.message);
                this.readArticles(data.type);
                data.deleted = true;
              } else {
                this.toastr.error(response.error.errorMessage);
              }
            },
            (error) => {
              this.toastr.error(error.errorMessage);
            }
          );
        }
      })
      .catch(() => {
        this.toastr.error(CANCEL);
      });
  }

  public pin(data: any){
    
    const obj = {
      id : data.id,
      feature : data.feature ? false : true
    }
    this.catalogService.featureArticle(obj).subscribe(
      response => {
        if(response.status === 0){
          this.toastr.success(response.message);
          this.readArticles(data.type);
        }else{
          this.errorHandler.handleError(response);
        }
      },
      error => {
        this.errorHandler.handleError(error);
      }
    )
  }

  public onUploadThumbnail($event: Event, data: any){
    $event.stopPropagation();
    this.uploadThumbnailChange.emit(data)

  }
}
